import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }

    // Phala: label each body cell with its column heading, so narrow screens can show rows as cards
    const headings = Array.from(table.querySelectorAll('thead th'), (th) => th.textContent?.trim() ?? '');
    if (headings.length < 2) return;

    for (const row of table.querySelectorAll('tbody tr')) {
      Array.from(row.cells).forEach((cell, index) => {
        const heading = headings[index];
        if (heading && !cell.hasAttribute('data-label')) cell.setAttribute('data-label', heading);
      });
    }

    table.classList.add('rte-table--labelled');
    table.style.setProperty('--rte-table-data-columns', String(headings.length - 1));
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
